import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "open-programs",
  "use": "open-programs-usage",
  "viewBox": "0 0 86.72 109.573",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 86.72 109.573\" id=\"open-programs\"><path d=\"M83.379 73.189L62.716 99.857l-.068-40.914 20.715-30.05zM59.314 57.844l.048 29.149-14.275 8.325.008-44.255 32.113-18.607zM3.353 28.9l38.409 22.176-.008 44.26-38.42-22.17zM81.699 26l-38.28 22.182-38.4-22.171 38.343-22.16zm-38.337-26L.022 25.05 0 75.088l43.425 25.058 15.943-9.3.03 18.726 27.316-34.457-.017-50.075L43.362 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol